import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'vunospecialchar'
})
export class ValidationPassNoSc implements PipeTransform {

  constructor() { }

  transform(value: string): string {
    // No special char
    const regex = /([!@#\$%\^\&*\)\(+=.,;:'<>\\{\\}\[\]\"`\\/\\|\\\_-])/;
    if (!value) {
      return 'invalid';
    }
    if (regex.test(value)) {
      return 'invalid';
    }
   return 'valid';
  }
}
